import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AuthGuard} from './auth.guard';
import {ContractorComponent} from './content/contractor/contractor.component';
import {UnitComponent} from './content/unit/unit.component';
import {TimetableComponent} from './content/timetable/timetable.component';
import {PremiumComponent} from './content/premium/premium.component';
import {PremiumFlyerComponent} from './content/premium-flyer/premium-flyer.component';
import {PasswordRenewComponent} from './password-renew/password-renew.component';
import {ChangePasswordComponent} from './content/change-password/change-password.component';


const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'renew-password', component: PasswordRenewComponent},
  {path: 'ustanova', component: DashboardComponent, canActivate: [AuthGuard]},
  {
    path: 'ustanova/:contractor', component: DashboardComponent, canActivate: [AuthGuard], children: [
      // {path: 'ustanova', component: ContractorComponent},
      {path: '', component: ContractorComponent},
      {path: 'enota', component: UnitComponent},
      {path: 'enota/:unit', component: UnitComponent},
      {path: 'urnik', component: TimetableComponent},
      {path: 'urnik/:timetable', component: TimetableComponent},
      {path: 'premium', component: PremiumComponent},
      {path: 'premium/:premium', component: PremiumComponent},
      {path: 'premium-flyer', component: PremiumFlyerComponent},
      {path: 'change-password', component: ChangePasswordComponent},
    ]
  },
  {
    path: '**',
    redirectTo: 'ustanova',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
